$(document).ready(function () {
    var elements = {
        'header': {
            '0px': {
                'height': '180px',
                'top': '0px'
            },
            '160px': {
                'height': '60px',
                'top': '0px'
            },
            '735px': {
                'height': '60px',
                'top': '0px'
            },
            '800px': {
                'height': '60px',
                'top': '-65px'
            }
        },
        'header section.top': {
            '0px': {
                'height': '40px'
            },
            '160px': {
                'height': '0px'
            }
        },
        'header section.bottom': {
            '0px': {
                'height': '140px'
            },
            '160px': {
                'height': '60px'
            }
        },
        'header section.bottom #logo': {
            '0px': {
                'height': '140px',
                'width': '336px'
            },
            '160px': {
                'height': '60px',
                'width': '220px'
            }
        },
        'header section.bottom #logo h1': {
            '0px': {
                'height': '140px'
            },
            '160px': {
                'height': '60px'
            }
        },
        'header section.bottom #main-nav': {
            '0px': {
                'top': '36px'
            },
            '160px': {
                'top': '0px'
            }
        }
    };

    if ($(window).width() <= 991) {
        elements['header section.bottom #main-nav .navbar-collapse'] = {
            '0px': {
                'top': '104px'
            },
            '160px': {
                'top': '60px'
            },
            '735px': {
                'top': '60px'
            },
            '800px': {
                'top': '-200px'
            }
        };
    }

    $('body').scrollAnimation({
        elements: elements
    });

    new WOW().init();
});
